// Keepalive cadence chosen to match the documented backend session timeout policy.
export const SESSION_KEEP_ALIVE_INTERVAL_MS = 10 * 60 * 1000;

export const SESSION_KEEP_ALIVE_ACTIVITY_EVENTS = Object.freeze([
  "click",
  "keydown",
  "mousemove",
  "scroll",
  "wheel",
  "touchstart",
]);

export const shouldKeepSessionAlive = ({
  isDocumentVisible,
  hadActivitySinceInterval,
}) => isDocumentVisible && hadActivitySinceInterval;
